module.exports = __webpack_public_path__ + "img/key.3e528048.svg";